import { render } from "./TraceRecordInference.vue?vue&type=template&id=7ec4a0c1"
import script from "./TraceRecordInference.vue?vue&type=script&lang=js"
export * from "./TraceRecordInference.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__